import NodeSidebar from 'Workflows/components/Builder/Sidebars/NodeSidebar'
import BranchSidebar from 'Workflows/components/Builder/Sidebars/BranchSidebar'
import EntrySidebar from 'Workflows/components/Builder/Sidebars/EntrySidebar'

export default function Sidebar() {
  const kind = useSel(s => s.local.sidebar.kind)

  return <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
    { kind === 'startNode' && <EntrySidebar /> }
    { kind === 'editNode' && <NodeSidebar /> }
    { kind === 'editBranch' && <BranchSidebar /> }
  </div>
}
